import { getInboundTransportTemplate } from "@/api/template";
import FileDownloader from "@/components/FileDownloader/FileDownloader";
import FileUploader from "@/components/FileUploader/FileUploader";
import HelpButton from "@/components/HelpButton/HelpButton";
import PageButtonGroup from "@/components/PageButtonGroup/PageButtonGroup";
import useTranslation from "@/hooks/useTranslation";
import { DownloadOutlined } from "@ant-design/icons";
import "../Transport.scss";
import { transportDetailUploadColumns, transportUploadFilters } from "../constants";

export default function InboundTransportButtonGroup() {
  const translation = useTranslation();

  return (
    <>
      <HelpButton
        type="text"
        url="https://help.root-sustainability.com/en/articles/9898979-inbound-transport"
      />
      <PageButtonGroup>
        <FileUploader
          uploadType={"inbound_transport"}
          buttonText={translation.transport.upload}
          uploadDataTableProps={{
            columns: transportDetailUploadColumns,
            rowKey: "key",
            availableFilters: transportUploadFilters,
          }}
          templateUrlFn={getInboundTransportTemplate}
        />
        <FileDownloader
          fileOutputName="template-inbound-transport.xlsx"
          fileUrlFn={getInboundTransportTemplate}
          icon={<DownloadOutlined />}
          buttonText="Template"
        />
      </PageButtonGroup>
    </>
  );
}
